var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5914 15.0538V9.46236C10.5914 4.23628 14.8284 0 20.0542 0H20.915C26.1413 0 30.3763 4.23682 30.3763 9.46236V15.0538H33.8172C34.7674 15.0538 35.5376 15.824 35.5376 16.7742V38.2796C35.5376 39.2297 34.7674 40 33.8172 40H6.72043C5.77026 40 5 39.2297 5 38.2796V16.7742C5 15.824 5.77026 15.0538 6.72043 15.0538H10.5914ZM14.8925 9.46236C14.8925 6.61203 17.2035 4.30108 20.0542 4.30108H20.915C23.7651 4.30108 26.0753 6.61148 26.0753 9.46236V15.0538H14.8925V9.46236ZM24.7849 27.5269C24.7849 29.9023 22.8593 31.828 20.4839 31.828C18.1085 31.828 16.1828 29.9023 16.1828 27.5269C16.1828 25.1515 18.1085 23.2258 20.4839 23.2258C22.8593 23.2258 24.7849 25.1515 24.7849 27.5269Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_Lock.148461bae0817bb3f5fd6a8f9338e04f.svg";
export { ForwardRef as ReactComponent };